import React from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_TEAM } from "../../GraphQL/Teams.js";
import { GET_SEASONS_CONTAINING_TEAM_ID } from "../../GraphQL/Season.js";
import { GET_PLAYERS_BY_TEAM_ID } from "../../GraphQL/Players.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import ManagerButton from "../../Components/Manager/ManagerButton.js";
import SeasonsTable from "../../Components/Season/SeasonsTable.js";
import PlayersTable from "../../Components/Player/PlayersTable.js";
import { Typography } from "@mui/material";

const TeamPage = (props) => {
  const { teamId } = useParams();

  const team = useQuery(GET_TEAM, {
    variables: { id: teamId },
  });

  const seasons = useQuery(GET_SEASONS_CONTAINING_TEAM_ID, {
    variables: { id: teamId },
  });

  const players = useQuery(GET_PLAYERS_BY_TEAM_ID, {
    variables: { id: teamId },
  });

  const queryError = team.error || seasons.error || players.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          team.refetch();
          seasons.refetch();
          players.refetch();
        }}
      />
    );
  }

  if (team.loading || seasons.loading || players.loading)
    return <LoadingSpinner />;

  console.log("TeamPage loaded", {
    teamId,
    teamName: team.data.team.name,
    playersByTeamId: players.data.playersByTeamId,
  });

  return (
    <PageLayout
      title={team.data.team.name}
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Teams", to: "/teams" },
        { label: team.data.team.name },
      ]}
    >
      <ManagerButton managerId={team.data.team.manager.id} />
      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Seasons</Typography>
      <SeasonsTable
        seasonsWithPermission={[]}
        seasons={seasons.data.seasonsContainingTeamId}
      />
      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Players</Typography>
      <PlayersTable
        playersWithPermission={[]}
        players={players.data.playersByTeamId}
      />
    </PageLayout>
  );
};

export default TeamPage;
